export default __webpack_public_path__ + "static/media/trus13.4d67b1bf.png";